import { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';
import { CircleLevelPartial, NextToken } from '../../_types/types.type';

interface ListCircleLevelByOrgResponse {
  listCircleLevelByOrg: {
    items: CircleLevelPartial[];
    nextToken: NextToken;
  };
}

interface ListCircleLevelByOrgVariables {
  orgID: string;
  nextToken: NextToken;
}

const fetchCircleLevels = async (): Promise<any> => {
  const fetchCircleLevelsQuery = gql`
    query MyQuery($orgID: ID!, $nextToken: String) {
      listCircleLevelByOrg(
        orgID: $orgID
        nextToken: $nextToken
        filter: { isDeleted: { eq: false } }
        limit: 10000
      ) {
        items {
          id
          name
          description
          levelNum
        }
      }
    }
  `;

  try {
    let levels: CircleLevelPartial[] = [];
    let nextToken: NextToken = null;
    do {
      const levelsRes = (await API.graphql(
        graphqlOperation(fetchCircleLevelsQuery, {
          //  @ts-ignore
          orgID: global.me.orgID,
          nextToken,
        } as ListCircleLevelByOrgVariables)
      )) as { data: ListCircleLevelByOrgResponse };

      const circleLevelsItems =
        levelsRes.data?.listCircleLevelByOrg?.items ?? [];
      levels = [...levels, ...circleLevelsItems];
      nextToken = levelsRes.data?.listCircleLevelByOrg?.nextToken;
    } while (nextToken);

    levels.sort((a, b) => (a.levelNum as number) - (b.levelNum as number));
    return levels;
  } catch (err) {
    console.error('Error fetching circle levels:', err);
    return null;
  }
};

export default fetchCircleLevels;
